import { Component, input } from '@angular/core';
import type { DailyFactHero } from '../../../../../shared/models/daily-fact-hero.model';

@Component({
  selector: 'app-daily-fact-hero',
  standalone: true,
  templateUrl: './daily-fact-hero.component.html',
  styleUrl: './daily-fact-hero.component.scss',
})
export class DailyFactHeroComponent {
  hero = input<DailyFactHero | null | undefined>();
}
